import React from "react";
import { UseFormReturn } from "react-hook-form";
import { useSentinels } from "../hooks";
import { Loading } from "../../../components";

interface ISentinelInput {
  form: UseFormReturn<any, any>;
  error?: string;
}

export const SentinelInput: React.FC<ISentinelInput> = ({ form }) => {
  const { data, loading } = useSentinels({ limit: 15, offset: 0, where: {} });

  const sentinelId = form.watch("sentinelId");

  if (loading) {
    return <Loading />;
  }

  return (
    <div className="flex flex-col">
      <label className="label">Sentinelle</label>
      <select
        className="input appearance-none w-full"
        {...form.register("sentinelId")}
      >
        {data?.sentinels?.results?.map((sentinel) => (
          <option value={sentinel.id} selected={sentinelId === sentinel.id}>
            {sentinel.ip}
          </option>
        ))}
      </select>
    </div>
  );
};
